import { HeartHandshake } from "lucide-react";

export const InviteBanner = ({ name, suffix = "invited you to Woven", testId = "invite-banner" }) => (
  <p
    data-testid={testId}
    className="status-pill mb-8 inline-flex bg-[#F2C98F] text-[#2C221E] shadow-[0_10px_24px_rgba(0,0,0,0.2)]"
  >
    <HeartHandshake className="h-5 w-5 shrink-0 text-[#B24E2A]" />
    <span><strong className="font-semibold">{name}</strong> {suffix}</span>
  </p>
);
